"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayloadAction_1 = require("./PayloadAction");
/**
 * Create an action creator function for the given action name and optional payload creator
 *
 * @param type - the type of the resulting actions
 * @param payloadCreator - When not provided then the resulting action creator will take no arguments and the actions it
 * creates will have no payload. When provided the resulting creator will take a single argument matching this function's
 * argument and the return value of this function will determine what the payload type is.
 */
exports.createAction = function (type, payloadCreator) {
    var helpers = {
        actionType: type,
        toString: function () { return type; },
    };
    var failed = Object.assign(function (err) { return PayloadAction_1.createFailedAction(type, err); }, helpers);
    var success = function (arg) {
        return PayloadAction_1.createSuccessAction(type, payloadCreator && payloadCreator(arg));
    };
    return Object.assign(success, helpers, { failed: failed });
};
